// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2RLk3","background":"App_background__25j4m","loading":"App_loading__b9Wo5"};